<template>
  <div>
    <div class="container-fluid p-0 bg-filter" :style="dynamicBgImg">
      <div class="row px-4" :class="{ 'bg-shadow': !websiteStore.getIsCampaign }">
        <div class="col-12 col-lg-4">
        </div>
        <div class="col-12 col-lg-4 py-lg-5">
          <div class="d-flex justify-content-center pb-3 pt-5">
            <h2 :style="getTitleStyle">
                  <b>{{ destinationDetails.name }}</b>
                </h2>
          </div>
          <div class="d-flex pb-lg-5">
            <div class="col-10">
              <select class="form-select form-control input" v-model="selected">
                <option v-for="destination in destinations.slice(0, 6)" :key="destination.id" :value="destination.id"
                  :hidden="destination.hidden">
                  {{ destination.name }}
                </option>
              </select>
            </div>
            <div class="col-2 px-xxl-3 px-1">
              <router-link :to="toRoute" custom v-slot="{ navigate }">
                  <button type="submit" class="btn submit material-icons-outlined arrow_forward" :style="getBtnStyle" @click="navigate">
                    arrow_forward
                  </button>
                </router-link>
            </div>
          </div>
          <div class="col text-center py-3 d-lg-none d-flex justify-content-center"><img src="../assets/images/campaigns/2026/mex-independence/branding/lbl.png" alt=""></div>
        </div>
        <!-- <div class="col-12 col-lg-4 d-flex justify-content-center align-items-end" v-if="websiteStore.getIsCampaign">
          <img :src="websiteStore.campaign.iconBanner.imgUrl" alt="" class="h-75">
        </div> -->
      </div>
    </div>
    <div class="container-fluid py-2"  :style="websiteStore.campaign.bgCampaign" v-if="websiteStore.getIsCampaign">
      <div class="col p-3 p-lg-0 d-grid d-lg-flex justify-content-center align-items-center"  :style="websiteStore.campaign.bgCampaign" >
    <div class="d-flex justify-content-center pe-2 pb-2 pb-md-0"><img :src="websiteStore.campaign.babyAsset" alt=""></div>
          <span class="campaign-font text-center pe-2">{{ websiteStore.campaign.lbl01 }}</span>
    

          <div class="d-flex justify-content-center pt-md-0 pt-2"><img :src="websiteStore.campaign.babyAsset" alt=""></div>
  
      
           <span class="campaign-font text-center px-3">{{ websiteStore.campaign.lbl02 }}</span>
           
            <a href="tel:+18776923883" class="text-decoration-none text-white"><span class="campaign-font-02 fs-4 text-white">{{ websiteStore.campaign.lbl03 }}</span></a>
      
      </div>
    </div>
  </div>
</template>

<script>
const getImagePath = (image = "") => {
  return require(`@/assets/images/filter_banner_imgs/${image}`)
}

import { useWebsiteStore } from '@/store/website';

export default {
  setup() {
    const websiteStore = useWebsiteStore();
    return {
      websiteStore
    }
  },
  props: {
    destinationDetails: {
      type: Object,
      default: function () {
        return {
          image: getImagePath("cover.webp"),
          name: "Look for the Best Vacation Deal",
          isHome: true
        }
      }
    },
    slug: String
  },
  watch: {
    slug(value) {
      this.checkSlug(value);
    }
  },
  data() {
    return {
      selected: 0,
      dynamicBgImg: '',
      titleStyle: '',
      isMobile: false,
      mobileMql: null
    };
  },
  computed: {
    dynamicBg() {
      return this.dynamicBgImg
    },
    destinations() {
      let destinations = [...this.websiteStore.destinations];

      destinations.forEach(x => {
        x.componentName = 'destination';
      });

      destinations.unshift({
        id: 0,
        name: this.isMobile ? 'Destinations' : 'Look for the Best Vacation Deal',
        componentName: 'home',
        hidden: true,
      });
      return destinations;
    },
    toRoute() {
      let destination = this.destinations.find(x => x.id == this.selected);

      let toRoute = { name: destination.componentName };

      if (destination.slug) {
        toRoute.params = {
          slug: destination.slug
        };
      }

      return toRoute;
    },
    getTitleStyle() {
      this.setTitleColor()
      return this.titleStyle
    },
    getBtnStyle() {
      if (this.websiteStore.getIsCampaign) {
        return this.websiteStore.campaign.btnFilter
      }
    }
  },
  methods: {
    checkSlug(slug) {
      if (slug) {
        this.selected = this.destinations.find(x => x.slug == slug).id;
      } else {
        this.selected = 0;
      }
    },
    setTitleColor() {
      if (this.websiteStore.getIsCampaign) {
        this.titleStyle = this.websiteStore.campaign.titleColor
      }
    },
    updateIsMobile(event) {
      this.isMobile = event.matches;
    }
  },
  mounted() {
    this.checkSlug(this.slug);
    if (this.websiteStore.getIsCampaign) {
      this.dynamicBgImg = this.dynamicBgImg = `background-image: url(${this.websiteStore.campaign.bgBanner.backgrImage});background-size: cover;`
    } else {
      this.dynamicBgImg = `background-image: url(${this.destinationDetails.image});background-size: cover;background-position: left !important;`;
    }

    this.mobileMql = window.matchMedia('(max-width: 991.98px)');
    this.isMobile = this.mobileMql.matches;
    this.mobileMql.addEventListener('change', this.updateIsMobile);
  },
  beforeUnmount() {
    if (this.mobileMql) {
      this.mobileMql.removeEventListener('change', this.updateIsMobile);
    }
  }
};
</script>

<style scoped>
.submit {
  background: var(---0c9491) 0% 0% no-repeat padding-box;
  background: #0c9491 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border-color: #ffffff;
  opacity: 1;
  height: 48px;
  width: 100%;
}

.submit:hover {
  background-color: #0A6B69;
}

.back-dark {
  background-color: rgba(0, 0, 0, 0.5);
}

.normal-back {
  background-color: transparent;
}

.title-banner {
  color: #ffff;
}

.card-title {
  color: #0c9491;
  font-weight: bold;
  font-size: 24px;
}

.card-text {
  font-size: 16px;
}

.btn-package {
  background: transparent linear-gradient(90deg, var(---0c9491) 0%, var(---3a2050) 100%) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(90deg, #0c9491 0%, #3a2050 100%) 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  color: #ffff;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  font-size: 12px;
}

.card-img-overlay {
  color: #ffff;
}

.place {
  font-size: 14px;
}

.retail-price {
  display: block;
  text-align: left;
  text-decoration: line-through;
  font: normal normal normal 12px/24px Poppins;
}

.price {
  text-align: left;
  font: normal normal bold 24px/24px Poppins;
}

.per {
  text-align: left;
  font: normal normal normal 12px/24px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  text-transform: uppercase;
  display: block;
}

.card-body {
  background-color: #fff;
}

.span {
  display: block;
}

.material-icons-outlined {
  line-height: none !important;
}

.input {
  border: 2px solid #0c9491;
  height: 48px;
}

h2 {
  font-size: 24px;
  font-family: 'Poppins';
  font-weight: bold;
  color: #ffff;
}

.campaign-font {
  font-family: Poppins !important;
  ;
  font-weight: 900;
  color: #fff;
}

.campaign-font-02 {
  font-family: Poppins !important;
  font-weight: 900;
  color: #fff;
}

.title-campaign {
  color: #ffffff;
}

.baby-asset {
  width: 7%;
}

.brandig-mobile {
  justify-items: center;
}

.bg-shadow {
  background-color: rgba(0, 0, 0, .2) !important;
} 
.bg-filter {
  background-position: left;
}

.arrow_forward {
  color: #fff;
}


@media (min-width: 992px) {
  .campaign-lbl-section {
    border-top: #025d20 2px solid;
  }
}
</style>